import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { Stack, Typography, Tabs, Tab, Box } from "@mui/material";
import colors from "../../../../../utils/colors";
import V2PageHeader from "../../../../common/V2PageHeader";
import SiteScopeGate from "../../../../common/SiteScopeGate";
import ConfigGeneralTabContent from "./components/ConfigGeneralTabContent";
import ConfigCustomBlockTabContent from "./components/ConfigCustomBlockTabContent";
import ConfigWAFConfigTabContent from "./components/ConfigWAFConfigTabContent";
import PermissionGate from "../../../../guards/PermissionGate";
import useSite from "../../../../../hooks/user/useSite";
import useAuth from "../../../../../hooks/useAuth";
import usePermissions from "../../../../../hooks/usePermissions";

const NewServicesWebApplicationConfig = () => {
  const { isAuthenticated } = useAuth();
  const { getSitesForItems, setErr } = useSite();  const { getPermissionsForSite, PERMISSIONS } = usePermissions();

  const [selectedTab, setSelectedTab] = useState("general");

  React.useEffect(() => {
    window.scrollTo(0, 0);
    if (isAuthenticated) {
      getSitesForItems();
    }
    return () => setErr(null);
  }, [isAuthenticated, getSitesForItems, setErr]);

  return (
    <PermissionGate permission={PERMISSIONS.WAF_READ} resourceLabel="WAF configuration">
    <>
      <Helmet title="WAF Configuration" />
      <Stack spacing={6} sx={{ p: 6 }}>
        <V2PageHeader
          title="WAF Configuration"
          helpTooltip="Configure Web Application Firewall protection for the selected site. Manage global WAF settings, Smart Parse and Signature WAF engines, custom block pages, and signature rule groups."
        />
        <SiteScopeGate mode="single">
          {(siteUid, { effectiveSiteId: siteID, selectedSite }) => {
            const canConfigureWAFForSite = selectedSite
              ? getPermissionsForSite(selectedSite).hasPermission(PERMISSIONS.WAF_CONFIGURE)
              : false;
            return (
              <>
                <Tabs
                  value={selectedTab}
                  onChange={(_, v) => setSelectedTab(v)}
                  sx={{
                    minHeight: "inherit",
                    height: 32,
                    "& .MuiTabs-flexContainer": { border: "none", px: 0, py: 0, gap: "8px", height: 32 },
                    "& .MuiTabs-indicator": { height: "1px", backgroundColor: colors.secondary[300] },
                    "& button": { p: 0, minWidth: "inherit", minHeight: "inherit" },
                    "& button .MuiTypography-root": { color: colors.neutral[700] },
                    "& .Mui-selected .MuiTypography-root": { color: colors.neutral[1000] },
                  }}
                >
                  <Tab value={"general"} label={<Typography sx={ { fontSize: 14 }}>General</Typography>} sx={{ width: 85 }} />
                  <Tab
                    value={"custom"}
                    label={<Typography sx={ { fontSize: 14 }}>Custom block page</Typography>}
                    sx={{ width: 160 }}
                  />
                  <Tab
                    value={"waf"}
                    label={<Typography sx={ { fontSize: 14 }}>Layerd Signatures</Typography>}
                    sx={{ width: 154 }}
                  />
                </Tabs>
                <Box>
                  {selectedTab === "general" && (
                    <ConfigGeneralTabContent siteUid={siteUid} canConfigureWAFForSite={canConfigureWAFForSite} />
                  )}
                  {selectedTab === "custom" && (
                    <ConfigCustomBlockTabContent siteUid={siteUid} canConfigureWAFForSite={canConfigureWAFForSite} />
                  )}
                  {selectedTab === "waf" && (
                    <ConfigWAFConfigTabContent siteUid={siteUid} canConfigureWAFForSite={canConfigureWAFForSite} />
                  )}
                </Box>
              </>
            );
          }}
        </SiteScopeGate>
      </Stack>
    </>
    </PermissionGate>
  );
};
export default NewServicesWebApplicationConfig;
